import {dateFilterParams} from '../../views/components/ag-grid/filter-params/DateComparator';

export default [
  {
    headerName: '',
    field: 'Policy_PK',
    tooltipField: 'Policy_PK',
    tooltipComponentParams: { field: 'Policy_PK' },
    minWidth: 50,
    filter: false,
    checkboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    headerCheckboxSelection: true,
    wrapText: false,
    autoHeight: false,
  },
  {
    headerName: 'Distributor',
    headerClass: 'header-text-wrap',
    field: 'Distributor',
    tooltipField: 'Distributor',
    tooltipComponentParams: { field: 'Distributor' },
    filter: 'agTextColumnFilter',
    minWidth: 150,
  },
  {
    headerName: 'PolicyIssueDate',
    headerClass: 'header-text-wrap',
    field: 'PolicyIssueDate',
    tooltipField: 'PolicyIssueDate',
    tooltipComponentParams: { field: 'PolicyIssueDate', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'Status',
    headerClass: 'header-text-wrap',
    field: 'Status',
    tooltipField: 'Status',
    tooltipComponentParams: { field: 'Status' },
    filter: 'agSetColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'CertificatePolicyNo',
    headerClass: 'header-text-wrap',
    field: 'CertificatePolicyNo',
    tooltipField: 'CertificatePolicyNo',
    tooltipComponentParams: { field: 'CertificatePolicyNo' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'UniqueIdentifier',
    headerClass: 'header-text-wrap',
    field: 'Identifier',
    tooltipField: 'Identifier',
    tooltipComponentParams: { field: 'Identifier' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InceptionDate',
    headerClass: 'header-text-wrap',
    field: 'InceptionDate',
    tooltipField: 'InceptionDate',
    tooltipComponentParams: { field: 'InceptionDate', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'ExpiryDate',
    headerClass: 'header-text-wrap',
    field: 'ExpiryDate',
    tooltipField: 'ExpiryDate',
    tooltipComponentParams: { field: 'ExpiryDate', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'FirstName',
    headerClass: 'header-text-wrap',
    field: 'InsuredFirstName',
    tooltipField: 'InsuredFirstName',
    tooltipComponentParams: { field: 'InsuredFirstName' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'Surname',
    headerClass: 'header-text-wrap',
    field: 'InsuredSurname',
    tooltipField: 'InsuredSurname',
    tooltipComponentParams: { field: 'InsuredSurname' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'CompanyName',
    headerClass: 'header-text-wrap',
    field: 'InsuredCompanyName',
    tooltipField: 'InsuredCompanyName',
    tooltipComponentParams: { field: 'InsuredCompanyName' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'Producer',
    headerClass: 'header-text-wrap',
    field: 'ProducerCompanyName',
    tooltipField: 'ProducerCompanyName',
    tooltipComponentParams: { field: 'ProducerCompanyName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'ProducerCode',
    headerClass: 'header-text-wrap',
    field: 'ProducerCompanyCode',
    tooltipField: 'ProducerCompanyCode',
    tooltipComponentParams: { field: 'ProducerCompanyCode' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredFiscalCode',
    headerClass: 'header-text-wrap',
    field: 'InsuredFiscalCode',
    tooltipField: 'InsuredFiscalCode',
    tooltipComponentParams: { field: 'InsuredFiscalCode' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'InsuredVATCode',
    headerClass: 'header-text-wrap',
    field: 'InsuredVATCode',
    tooltipField: 'InsuredVATCode',
    tooltipComponentParams: { field: 'InsuredVATCode' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  // {
  //   headerName: 'ClassOfBusiness',
  //   headerClass: 'header-text-wrap',
  //   field: 'ClassOfBusiness',
  //   filter: 'agTextColumnFilter',
  //   minWidth: 210,
  // },
  {
    headerName: 'Profession',
    headerClass: 'header-text-wrap',
    field: 'Profession',
    tooltipField: 'Profession',
    tooltipComponentParams: { field: 'Profession' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'AddressLine1',
    headerClass: 'header-text-wrap',
    field: 'AddressLine1',
    tooltipField: 'AddressLine1',
    tooltipComponentParams: { field: 'AddressLine1' },
    filter: 'agTextColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'InsuredTurnover',
    headerClass: 'header-text-wrap',
    field: 'InsuredTurnover',
    tooltipField: 'InsuredTurnover',
    tooltipComponentParams: { field: 'InsuredTurnover' },
    filter: 'agNumberColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'LimitOfIndemnity',
    headerClass: 'header-text-wrap',
    field: 'LimitOfIndemnity',
    tooltipField: 'LimitOfIndemnity',
    tooltipComponentParams: { field: 'LimitOfIndemnity' },
    filter: 'agNumberColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'Excess',
    headerClass: 'header-text-wrap',
    field: 'Excess',
    tooltipField: 'Excess',
    tooltipComponentParams: { field: 'Excess' },
    filter: 'agNumberColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'FinalPremium',
    headerClass: 'header-text-wrap',
    field: 'FinalPremium',
    tooltipField: 'FinalPremium',
    tooltipComponentParams: { field: 'FinalPremium' },
    filter: 'agNumberColumnFilter',
    minWidth: 210,
  },
  {
    headerName: 'RetroactiveDate',
    headerClass: 'header-text-wrap',
    field: 'RetroactiveDate',
    tooltipField: 'RetroactiveDate',
    tooltipComponentParams: { field: 'RetroactiveDate', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'RetroactivePeriod',
    headerClass: 'header-text-wrap',
    field: 'RetroactivePeriod',
    tooltipField: 'RetroactivePeriod',
    tooltipComponentParams: { field: 'RetroactivePeriod', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
  },
  {
    headerName: 'DownloadCertificate',
    headerClass: 'header-text-wrap',
    field: 'DownloadCertificate',
    filter: false,
    minWidth: 150,
    cellRenderer: 'CellRendererDownload',
    cellClass: 'flex justify-center',
    cellRendererParams(params) {
      return {
        iconType: 'fal',
        icon: 'file-download',
        documentType: 'policyCertificate',
      }
    },
  },
];

